import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import FormattedHTMLMessage from './FormattedHTMLMessage';

function InternalLink ({ message, href, className, noUnderline }) {
    const messageClassName = classnames('internal-link', {
        'internal-link-no-underline': noUnderline
    });

    return (
        <a href={ href } className={ classnames('external-link-no-underline', className) }>
            <FormattedHTMLMessage className={ messageClassName } message={ message } />
        </a>
    );
}

InternalLink.propTypes = {
    message: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    className: PropTypes.string,
    noUnderline: PropTypes.bool,
    srOnly: PropTypes.string
};

InternalLink.defaultProps = {
    className: '',
    noUnderline: false,
    srOnly: ''
};

export default InternalLink;



// WEBPACK FOOTER //
// ./src/components/general/InternalLink.js